import React from "react";
import {Link} from "react-router-dom";
import HoverImageComponent from "../components/HoverImageComponent";
import { hoverImageData } from "../constants/data";

function Portfolio() {
  return (
    <section id="portfolio">
      <div className="bg-black py-4">
        <h1 className="text-center text-gray-300 py-10 uppercase text-sm tracking-[4px]">Ziva Interiors Designs For Every Room</h1>
        <HoverImageComponent data={hoverImageData} />
        <div className=" flex justify-center py-10">
          <Link to="portfolio" className="border border-white rounded-sm p-2 px-4 text-white hover:bg-white hover:text-black transitions">
            Explore our portfolio
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
